<template>
  <div class="editEmployeePersonalVue">
    <!-- HUGE COMMENT -->
    <!-- Please add autocomplete='off' to all input fields or at form level -->

    <div class="c-responsive-fixwidth">
        <div class="clearfix o-skillset-area">
            <form autocomplete="off">
                <div class="employer-info">
                    <div class="field-group">
                        <div class="row">
                            <div class="col-sm-3">
                                <div class="c-common-space c-common-box-shadow c-radius3">
                                    <div class="c-user-tab-content clearfix o-skillset-area">
                                        <div class="layout-table">
                                            <div class="layout-table-cell">
                                                <div class="form-group employerpic-upload-sec">
                                                    <div class="employerpic-upload">
                                                        <img :src="empProfile" :alt="$t('cropped_image')" id='img-upload' />
                                                <!-- <img v-if="empProfile != '' && empProfile != 'NULL'" :src="(this.empProfile)"  id='img-upload'/>
                                                    <img v-if="empProfile == '' ||  empProfile == 'NULL'" src="static/assets/images/user1.png" id='img-upload' /> -->
                                                    </div>
                                                    <div class="employerpic-upload-btn o-upload-profile-btn">
                                                        <div class="input-group">
                                                            <span class="input-group-btn">
                                                                <span class="btn btn-default btn-file">
                                                                <input type="file" id="imgInp" @change="addProfileImg($event)" accept="image/*" />
                                                                </span>
                                                            </span>
                                                            <input type="text" class="form-control" readonly>
                                                        </div>
                                                        <i class="fa fa-plus"></i>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-9">
                                
                                <div class="c-common-space c-common-box-shadow c-radius3">
                                    <div class="c-user-tab-content clearfix o-skillset-area">
                                        <p>{{ $t('basic_info') }} </p>
                                        <div class="row">
                                            <div class="col-sm-4">
                                                <div class="form-group">
                                                    <label class="common-label-text form-label">{{ $t('nick_name') }} :<!-- <span class="req-text">*</span> --></label>
                                                    <!-- @blur="blur($event)" v-validate="'required'" -->
                                                    <input autocomplete="random" v-model="empPersonal.basicInfo.userName" @change="onUpdateInputField" name="userName" data-vv-delay="500" type="text" class="form-control" :placeholder="$t('user_name')" >
                                                    <!-- <span v-show="errors.has('userName') && this.validation_err!=0" class="err-msg">{{ errors.first('userName') }}</span> -->
                                                </div>
                                            </div>
                                            <!-- {{ userRoleSlug }} -->
                                            <div v-if="currentEmployeeID == loginEmployeeId && userRoleSlug == 'client-admin'">
                                                <div class="col-sm-4">
                                                    <div class="form-group ">
                                                        <label class="common-label-text form-label">{{ $t('password')}}:<span class="req-text">*</span></label>
                                                        <input autocomplete="random" @change="onUpdateInputField" name="password" v-model="empPersonal.basicInfo.password" data-vv-delay="500" type="password" class="form-control" :placeholder="$t('password')">
                                                        <!-- <span v-show="errors.has('password') && this.validation_err!=0" class="err-msg">{{ errors.first('password') }}</span> -->
                                                        <span class="err-msg">**{{ $t('required_field') }}**</span>
                                                    </div>
                                                </div>
                                                <div class="col-sm-4">
                                                    <div class="form-group ">
                                                        <label class="common-label-text form-label">{{ $t('confirm_password') }}:<span class="req-text">*</span></label>
                                                        <input autocomplete="random" @change="onUpdateInputField" v-model="empPersonal.basicInfo.cnfPassword" type="password" class="form-control" :placeholder="$t('repeat_password')" name="cnfPassword" data-vv-delay="500">
                                                        <!-- <span v-show="errors.has('cnfPassword') && this.validation_err!=0" class="err-msg">{{ errors.first('cnfPassword') }}</span> -->
                                                        <span class="err-msg">**{{ $t('required_field') }}**</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div v-else-if="(currentEmployeeID != loginEmployeeId) || (currentEmployeeID == loginEmployeeId)" class="col-sm-8">
                                                <div class="form-group ">
                                                    <label class="common-label-text form-label">{{ $t('change_password') }}:</label><br>
                                                    <a href="javascript: void(0)" @click="resetlink()" class="c-common-btn c-common-btn--small c-common-btn--inverse-icon-green"><i class="fa fa-unlock-alt"></i> {{ $t('send_reset_link') }}</a>
                                                </div>
                                            </div>
                                            </div>
                                        <div class="row">
                                            <div class="col-sm-6">
                                                <div class="form-group ">
                                                    <label class="common-label-text form-label">{{ $t('first_name') }}:<span class="req-text">*</span></label>
                                                    <input autocomplete="random" @change="onUpdateInputField" v-model="empPersonal.basicInfo.firstName" type="text" class="form-control o-capitalize-field" :placeholder="$t('first_name')" v-validate="'required|alpha'" @blur="blur($event)" name="firstName" data-vv-delay="500">
                                                    <span class="err-msg">**{{ $t('required_field') }}**</span>
                                                </div>
                                            </div>
                                            <div class="col-sm-6">
                                                <div class="form-group ">
                                                    <label class="common-label-text form-label">{{ $t('last_name') }}:<span class="req-text">*</span></label>
                                                    <input autocomplete="random" @change="onUpdateInputField" v-model="empPersonal.basicInfo.lastName" type="tel" class="form-control o-capitalize-field" :placeholder="$t('last_name')" v-validate="'required|alpha'" @blur="blur($event)" name="lastName" data-vv-delay="500">
                                                    <span class="err-msg">**{{ $t('required_field') }}**</span>
                                                    <!-- <span v-show="errors.has('lastName') && this.validation_err!=0" class="err-msg">{{ errors.first('lastName') }}</span> -->
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="field-group">
                        <div class="row">
                            <div class="col-sm-12">
                                <div class="u-bg-color-fff c-common-space c-common-box-shadow c-radius3 ">
                                    <div class="row">
                                        <div class="col-sm-6">
                                            <div class="c-user-tab-content clearfix o-skillset-area">
                                                <p>Email:</p>
                                                <div class="row">
                                                    <div class="col-sm-6">
                                                        <div class="form-group ">
                                                        <label class="common-label-text form-label">Primary Email:<span class="req-text">*</span></label>
                                                 
                                                         <input autocomplete="random" @keyup="customValEmail($event, empPersonal.contact.email)" v-model="empPersonal.contact.email" type="text" class="form-control" :placeholder="$t('primary_email')" v-validate="'required|email'" @blur="blur($event)" name="email" data-vv-delay="500">                                                        

                                                        <span v-if="emailExistNote == 1 && !errors.has('email')" class="customExisticon o-customExisticon-tick">
                                                            <i class="fa fa-check" aria-hidden="true"></i>
                                                        </span>
                                                        <span v-else-if="emailExistNote == 0 || errors.has('email')" class="customExisticon o-customExisticon-cross">
                                                            <i class="fa fa-times" aria-hidden="true"></i>
                                                        </span>
                                                        
                                                        <!-- <span class="o-customExisticon-cross" v-if="emailExistNote == 0">
                                                             {{($t('email_already_exist'))}}</span> -->
                                                        <span v-if="errors.has('email')" class="err-msg">{{ errors.first('email') }}</span>
                                                        <div class="o-customExisticon-cross" v-else-if="emailExistNote == 0">
                                                            <span>
                                                            {{ $t('email_already_exist') }} 
                                                            </span>
                                                            <span>{{ $t('please_visit_faq') }}</span>
                                                            <br />
                                                            <a href="https://cs3.me/eae" target="_blank"> Faq - Email Exists </a>
                                                        </div>

                                                    </div>
                                                    </div>
                                                    <div class="col-sm-6">
                                                        <div class="form-group ">
                                                            <label class="common-label-text">{{ $t('secondary_email') }}:</label>
                                                            <input autocomplete="random" @change="onUpdateInputField" v-model="empPersonal.contact.secEmail" type="email" class="form-control" :placeholder="$t('secondary_email')">
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-6">
                                            <div class="c-user-tab-content clearfix o-skillset-area">
                                                <p>{{ $t('phone') }}:</p>
                                                <div class="row">
                                                    <div class="col-sm-6">
                                                        <div class="form-group ">
                                                            <label class="common-label-text form-label">{{ $t('home_phone') }}:</label>
                                                            <input autocomplete="random" @change="onUpdateInputField" v-model="empPersonal.contact.homePhone" type="tel" class="form-control" v-validate="{ regex: /^\d{10,15}$/g}" data-vv-delay="500" :placeholder="$t('home_phone')" name="homePhone" v-on:keyup="blurHomePhone($event, empPersonal.contact.homePhone)">
                                                            <span v-show="errors.has('homePhone')" class="err-msg">
                                                                {{ $t('home_phone_validation')}} </span>
                                                            <!-- <span v-else class="err-msg">10 - 15 digits- Exclude all Dots, Spaces and Dashes.</span> -->
                                                        </div>
                                                    </div>
                                                    <!-- {{ empPersonal.contact.cellPhone }} -->
                                                    <div class="col-sm-6">
                                                        <div class="form-group ">
                                                            <label class="common-label-text form-label">{{ $t('cell_phone') }}:<!-- <sup>*</sup> --></label>
                                                            <input autocomplete="random" @change="onUpdateInputField" v-model="empPersonal.contact.cellPhone" type="tel" class="form-control" v-validate="'required'" data-vv-delay="500" :placeholder="$t('cell_phone')" name="cellPhone" v-on:keyup="blurCellPhone($event, empPersonal.contact.cellPhone)">
                                                            <span v-if="errors.has('cellPhone')" class="err-msg">
                                                                {{ $t('cell_phone_validation') }} 
                                                            </span>

                                                            <!-- <span v-else class="err-msg">10 - 15 digits- Exclude all Dots, Spaces and Dashes.</span> -->
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="field-group">
                        <div class="row">
                            <div class="col-sm-12">
                                <div class="c-common-space c-common-box-shadow c-radius3">
                                    <div class="c-user-tab-content clearfix o-skillset-area">
                                        <p>{{ $t('address') }}:</p>
                                        <div class="row">
                                            <div class="col-sm-8">
                                                <div class="form-group ">
                                                    <label class="common-label-text form-label">{{ $t('street_address') }}:<!-- <sup>*</sup> --></label> <!-- v-validate="'required'" @blur="blur($event)" -->                              
                                                    <input autocomplete="random" @change="onUpdateInputField" v-model="empPersonal.address.streetAdd" type="text" class="form-control o-capitalize-field" :placeholder="$t('street_address')" name="streetAdd" data-vv-delay="500">
                                                    <!-- <span v-show="errors.has('streetAdd') && this.validation_err!=0" class="err-msg">{{ errors.first('streetAdd') }}</span> -->
                                                </div>
                                            </div>
                                            <div class="col-sm-4">
                                                <div class="form-group ">
                                                    <label class="common-label-text form-label">{{ $t('city') }}:<!-- <sup>*</sup> --></label>
                                                    <!-- v-validate="'required'" @blur="blur($event)" -->
                                                    <input autocomplete="random" @change="onUpdateInputField" v-model="empPersonal.address.city" type="text" class="form-control o-capitalize-field" :placeholder="$t('city')"  name="city" data-vv-delay="500">
                                                    <!--  <span v-show="errors.has('city') && this.validation_err!=0" class="err-msg">{{ errors.first('city') }}</span> -->
                                                </div>
                                            </div>
                                            <div class="col-sm-4">
                                                <div class="form-group ">
                                                    <label class="common-label-text form-label">{{ $t('state') }}:<!-- <sup>*</sup> --></label>
                                                    <!-- v-validate="'required'" @blur="blur($event)" -->
                                                    <input autocomplete="random" @change="onUpdateInputField" v-model="empPersonal.address.state" type="text" class="form-control o-capitalize-field" :placeholder="$t('state')" name="state" data-vv-delay="500">
                                                    <!-- <span v-show="errors.has('state') && this.validation_err!=0" class="err-msg">{{ errors.first('state') }}</span> -->
                                                </div>
                                            </div>
                                            <div class="col-sm-4">
                                                <div class="form-group ">
                                                    <label class="common-label-text form-label">{{ $t('zip') }}:<!-- <sup>*</sup> --></label>
                                                    <!-- v-validate="'required'" @blur="blur($event)"  -->
                                                    <input autocomplete="random" @change="onUpdateInputField" v-model="empPersonal.address.zip" type="text" class="form-control" :placeholder="$t('zip')" name="zip" data-vv-delay="500">
                                                    <!-- <span v-show="errors.has('zip') && this.validation_err!=0" class="err-msg">{{ errors.first('zip') }}</span> -->
                                                    <span class="err-msg">** {{ $t('remove_spaces_dots_dashes') }} **</span>
                                                </div>
                                            </div>
                                            <div class="col-sm-4">
                                                <div class="form-group ">
                                                    <label class="common-label-text form-label">{{ $t('country') }}:<!-- <sup>*</sup> --></label>
                                                    <!-- v-validate="'required'" @blur="blur($event)" -->
                                                    <div class="o-cutsomSelect">
                                                        <select @change="onUpdateInputField" v-model="empPersonal.address.country"  name="country" data-vv-delay="500">
                                                            <option value="">{{ $t('country') }}</option>
                                                            <option value="USA">USA</option>
                                                            <option value="Canada">Canada</option>
                                                            <option value="UK">UK</option>
                                                            <!-- <option value="India">India</option> -->
                                                        </select>
                                                        <!-- <span v-show="errors.has('country') && this.validation_err!=0" class="err-msg">{{ errors.first('country') }}</span> -->
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="field-group">
                        <div class="row">
                            <div class="col-sm-12">
                                <div class="c-common-space c-common-box-shadow c-radius3">
                                    <div class="c-user-tab-content clearfix o-skillset-area">
                                        <p>{{ $t('po_box_address') }}:</p>
                                        <div class="row">
                                            <div class="col-sm-8">
                                                <div class="form-group ">
                                                    <label class="common-label-text">{{ $t('p_o_box') }}:</label>
                                                    <input autocomplete="random" @change="onUpdateInputField" v-model="empPersonal.PoBoxAddress.pbAdd" type="text" class="form-control" :placeholder="$t('p_o_box')">
                                                </div>
                                            </div>
                                            <div class="col-sm-4">
                                                <div class="form-group ">
                                                    <label class="common-label-text">{{ $t('city') }}:</label>
                                                    <input autocomplete="random" @change="onUpdateInputField" v-model="empPersonal.PoBoxAddress.city" type="text" class="form-control" :placeholder="$t('city')">
                                                </div>
                                            </div>
                                            <div class="col-sm-4">
                                                <div class="form-group ">
                                                    <label class="common-label-text">{{ $t('state') }}:</label>
                                                    <input autocomplete="random" @change="onUpdateInputField" v-model="empPersonal.PoBoxAddress.state" type="text" class="form-control" :placeholder="$t('state')">
                                                </div>
                                            </div>
                                            <div class="col-sm-4">
                                                <div class="form-group ">
                                                    <label class="common-label-text">{{ $t('zip') }}:</label>
                                                    <input autocomplete="random" @change="onUpdateInputField" v-model="empPersonal.PoBoxAddress.zip" type="text" class="form-control" :placeholder="$t('zip')">
                                                    <span class="err-msg">** {{ $t('remove_spaces_dots_dashes') }} **</span>
                                                </div>
                                            </div>
                                            <div class="col-sm-4">
                                                <div class="form-group ">
                                                    <label class="common-label-text">{{ $t('country') }}:</label>
                                                
                                                    <div class="o-cutsomSelect">
                                                        <select @change="onUpdateInputField" v-model="empPersonal.PoBoxAddress.country" placeholder="Country">
                                                            <option value="">{{ $t('country') }}</option>
                                                            <option value="USA">USA</option>
                                                            <option value="UK">UK</option>
                                                            <option value="Canada">Canada</option>
                                                            <!-- <option value="India">India</option> -->
                                                        </select>
                                                    
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div v-if="false" class="field-group">
                        <div class="row">
                            <div class="col-sm-12">
                                <div class="c-common-space c-common-box-shadow c-radius3">
                                    <div class="c-user-tab-content clearfix o-skillset-area">
                                        <p>{{ $t('identity_fields_outsourced')}}:</p>
                                        <div class="row">
                                            <div class="col-sm-3">
                                                <div class="form-group ">
                                                    <label class="common-label-text">{{ $t('driving_license')}}:</label>
                                                    <input autocomplete="random" @change="onUpdateInputField" v-model="empPersonal.identityField.driverLicense" type="number" class="form-control" :placeholder="$t('driving_license')">
                                                </div>
                                            </div>
                                            <div class="col-sm-3">
                                                <div class="form-group ">
                                                    <label class="common-label-text">{{ $t('social_security') }} :</label>
                                                    <input autocomplete="random" @change="onUpdateInputField" v-model="empPersonal.identityField.socialSecurity" type="text" class="form-control" :placeholder="$t('social_security')">
                                                </div>
                                            </div>
                                            <div class="col-sm-3">
                                                <div class="form-group ">
                                                    <label class="common-label-text">{{ $t('mothers_maiden_name') }}:</label>
                                                    <input autocomplete="random" @change="onUpdateInputField" v-model="empPersonal.identityField.monthMaidenName" type="text" class="form-control" :placeholder="$t('mothers_maiden_name')">
                                                </div>
                                            </div>
                                            <div class="col-sm-3">
                                                <div class="form-group ">
                                                    <label class="common-label-text">{{$t('date_of_birth')}}:</label>
                                                    <!-- <input autocomplete="random" type="tel" class="form-control" placeholder="yyyyy-mm-dd"> -->
                                                    <el-date-picker 
                                                    @change="onUpdateInputField" 
                                                    name="date" 
                                                    v-model="empPersonal.identityField.dataOfBirth" 
                                                    v-validate="{ required: true}" 
                                                    type="date" 
                                                    :format="getDisplayFormat()" 
                                                    value-format="yyyy-MM-dd" 
                                                    :placeholder="getDatePlaceholder()" 
                                                    class="fullwidth-input">
                                                    </el-date-picker>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div v-if="true" class="field-group">
                        <div class="row">
                            <div class="col-sm-12">
                                <div class="c-common-space c-common-box-shadow c-radius3">
                                    <div class="c-user-tab-content1 clearfix o-skillset-area">
                                        <p class="content-title">
                                            {{ $t('emergency_card') }}:                                   
                                            <span class="disclaimer-note">
                                                The information provided to Emergency Contact Data is owned by you and will be voluntarily shared by CallSteward, LLC to the relevant Administrative, Power Users, and  Stewards, within the CallSteward system, in the regular execution of their duties.<br />
                                                DO NOT SHARE ANY information that you feel violates your privacy.<br />
                                                This information is collected to expedite communication on your behalf in a health emergency.
                                            </span>
                                        </p>
                                        <!-- French "emergency_card": "Carte d’urgence (administrateur, utilisateur expérimenté, délégué syndical)", -->
                                        <!--Spanish "emergency_card": "Tarjeta de emergencia (administrador, usuario inteligente, administrador de trabajos)", -->
                                        <!-- English "emergency_card":"Emergency Card (admin, power user, job steward)",  -->
                                        <div class="content-body row">
                                            <div class="col-sm-6">
                                                <div class="form-group ">
                                                    <label class="common-label-text">{{ $t('contact_name') }}:</label>
                                                    <input autocomplete="random" @change="onUpdateInputField" v-model="empPersonal.emergency.contactName" type="text" class="form-control" :placeholder="$t('contact_name')">
                                                </div>
                                            </div>
                                            <div class="col-sm-6">
                                                <div class="form-group ">
                                                    <label class="common-label-text">{{ $t('contact_number') }}:</label>
                                                    <input autocomplete="random" @change="onUpdateInputField" v-model="empPersonal.emergency.contactNumber" type="number" class="form-control" :placeholder="$t('contact_number')">
                                                </div>
                                            </div>
                                            
                                            <div class="col-sm-6">
                                                <div class="form-group ">
                                                    <label class="common-label-text">{{ $t('home_phone') }}:</label>
                                                    <input autocomplete="random" @change="onUpdateInputField" v-model="empPersonal.emergency.homePhone" type="number" class="form-control" :placeholder="$t('home_phone')">
                                                </div>
                                            </div>
                                            <div class="col-sm-6">
                                                <div class="form-group ">
                                                    <label class="common-label-text">{{ $t('cell_phone') }}:</label>
                                                    <input autocomplete="random" @change="onUpdateInputField" v-model="empPersonal.emergency.cellPhone" type="number" class="form-control" :placeholder="$t('cell_phone')">
                                                </div>
                                            </div>
                                            <!-- <div class="col-sm-4">
                                                <div class="form-group ">
                                                    <label class="common-label-text">{{ $t('email') }}:</label>
                                                    <input autocomplete="random" @change="onUpdateInputField" v-model="empPersonal.emergency.email" type="email" class="form-control" :placeholder="$t('email')">
                                                </div>
                                            </div> -->
                                            <div class="col-sm-6">
                                                <div class="form-group ">
                                                    <label class="common-label-text">{{ $t('medical_conditions_note')}}:</label>
                                                    <textarea autocomplete="random" :placeholder="$t('medical_notes')" class="form-control" rows="4" @change="onUpdateInputField" v-model="empPersonal.emergency.medicalCondition"></textarea>
                                                </div>
                                            </div>
                                            <div class="col-sm-6">
                                                <div class="form-group ">
                                                    <label class="common-label-text">{{ $t('regular_medications') }}:</label>
                                                    <textarea autocomplete="random" :placeholder="$t('regular_medications')" class="form-control" rows="4" @change="onUpdateInputField" v-model="empPersonal.emergency.regularMedication" ></textarea>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="(custom_field_1 != '' && custom_field_1 != null && getPower('editCustomFields')) || (custom_field_2 != '' && custom_field_2 != null && getPower('editCustomFields'))" class="field-group">
                        <div class="row">
                            <div class="col-sm-12">
                                <div class="u-bg-color-fff c-common-space c-common-box-shadow c-radius3 ">
                                    <div class="row">
                                        <div class="col-sm-12">
                                            <div class="c-user-tab-content clearfix o-skillset-area">
                                                <p>{{ $t('custom_fields') }}:</p>
                                                <div class="row">
                                                    <div v-if="custom_field_1 != '' && custom_field_1 != null" class="col-sm-6">
                                                        <div class="form-group ">
                                                            <label class="common-label-text">{{custom_field_1}}:</label>
                                                            <input autocomplete="random" @change="onUpdateInputField" v-model="empPersonal.customFields.custom_field_1" type="text" class="form-control" :placeholder="custom_field_1">
                                                        </div>
                                                    </div>
                                                    <div v-if="custom_field_2 != '' && custom_field_2 != null" class="col-sm-6">
                                                        <div class="form-group ">
                                                            <label class="common-label-text">{{custom_field_2}}:</label>
                                                            <input autocomplete="random" @change="onUpdateInputField" v-model="empPersonal.customFields.custom_field_2" type="text" class="form-control" :placeholder="custom_field_2">
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>

        </div>
    </div>
    <modal name="crop-image"  height="auto" :scrollable="true" class="modal-dialog modal-sm">
        <div class="modal-add-newJob" tabindex="-1" role="dialog">
            <div  role="document">
                <div class="modal-content o-common-modal-content">
                    <div class="modal-header u-no-border text-center o-small-modal-head">
                        <button @click="closeCropModal()" type="button" class="close custom-modal--close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                        <h4 class="modal-title">{{ $t('edit_image') }}</h4>
                    </div>
                    <div class="modal-body c-common-box-shadow o-modal-nopad-body">
                        <div class="row">
                            <div class="col-sm-6">
                                 <div class="c-common-space c-radius3">
                                     <div class="c-user-tab-content clearfix o-skillset-area">
                                         <div class="layout-table">
                                             <div class="layout-table-cell">
                                                 <div class="employerpic-upload-sec">
                                                     <!-- <div class="employerpic-upload"> -->
                                                         <!-- <vue-cropper
                                                          ref="cropper"
                                                          :src="cropableImgPath"
                                                          alt="Source Image"
                                                        >
                                                        </vue-cropper> -->
                                                     <!-- </div> -->
                                                     <vue-cropper
                                                        ref="cropper"
                                                        :guides="true"
                                                        :view-mode="0"
                                                        drag-mode="crop"
                                                        :auto-crop-area="0.5"
                                                        :min-container-width="250"
                                                        :min-container-height="180"
                                                        :background="true"
                                                        :rotatable="true"
                                                        :src="cropableImg"
                                                        alt="Source Image"
                                                      >
                                                    </vue-cropper>

                                                        <!-- :img-style="{ width: '400px', height: '300px' }" -->
                                                 </div>
                                             </div>
                                         </div>
                                     </div>
                                 </div>
                            </div>
                            <div class="col-sm-6">
                                 <div class="c-common-space c-radius3">
                                     <div class="c-user-tab-content clearfix o-skillset-area">
                                         <div class="layout-table">
                                             <div class="layout-table-cell">
                                                 <div class="employerpic-upload-sec">
                                                    <div>
                                                        <a href="javascript: void(0)" @click="cropImage()" v-if="cropableImg != ''" data-dismiss="modal" aria-label="Close" class="btn c-common-btn c-common-btn--large c-common-btn--inverse-icon-blue"><i class="fa fa-crop" aria-hidden="true"></i> {{ $t('crop')}}</a>

                                                        <a href="javascript: void(0)" @click="rotate" v-if="cropableImg != ''" data-dismiss="modal" aria-label="Close" class="btn c-common-btn c-common-btn--large c-common-btn--inverse-icon-blue"><i class="fa fa-repeat" aria-hidden="true"></i>{{ $t('rotate')}} </a>
                                                    </div>
                                                    <div class="crop-image-top-margin">
                                                        <img
                                                          v-if="cropImg && cropImg!=''"
                                                          :src="cropImg"
                                                          style="width: 200px; border: 1px solid gray"
                                                          :alt="$t('cropped_image')"
                                                        />
                                                    </div>
                                                    
                                                    
                                                 </div>
                                             </div>
                                         </div>
                                     </div>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div class="modal-footer text-center">
                        <ul class="o-filter-area">
                            <li>
                                <a href="javascript: void(0)" @click="completeEdit()" data-dismiss="modal" aria-label="Close" class="btn c-common-btn c-common-btn--large c-common-btn--green"><i class="fa fa-floppy-o" aria-hidden="true"></i>{{ $t('done') }}</a>
                            </li>
                            <li>
                                <a href="javascript: void(0)" @click="closeCropModal()" data-dismiss="modal" aria-label="Close" class="btn c-common-btn c-common-btn--large c-common-btn--inverse-icon-blue"><i class="fa fa-minus-circle" aria-hidden="true"></i>
                                {{ $t('cancel') }}</a>
                            </li>
                            
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </modal>
  </div>
</template>
<script>
    import {
        mapGetters,
        mapActions
    } from 'vuex';
    import {
        global
    } from '../../global.js';
    import {
        bus
    } from '../../main';
    import dateTimeConvert from '../../timeConvert&Compare.js';
    import service from '../../services.js';
    import VueCropper from 'vue-cropperjs';
    import 'cropperjs/dist/cropper.css';

    export default {
        props: {
            empDetails: {
                type: Object,
                required: true
            }
        },
        components: { 
            VueCropper
        },
        data() {
            return {
                employeePrimaryEmail: '',
                home_phone_error: false,
                cell_phone_error: false,
                currentEmployeeID:'',
                empProfile: '',
                cropImg:'',
                cropableImg:'',
                getBaseURL: '',
                validation_err: 0,
                personalDetails: {},
                custom_field_1: '',
                custom_field_2: '',
                img_format:['jpg', 'jpeg', 'png', 'gif'],
                empPersonal: {
                    basicInfo: {
                        userName: '',
                        password: '',
                        cnfPassword: '',
                        firstName: '',
                        lastName: '',
                    },
                    address: {
                        streetAdd: '',
                        city: '',
                        state: '',
                        zip: '',
                        country: '',

                    },
                    PoBoxAddress: {
                        pbAdd: '',
                        city: '',
                        state: '',
                        zip: '',
                        country: '',

                    },
                    contact: {
                        email: '',
                        secEmail: '',
                        homePhone: '',
                        cellPhone: '',
                    },
                    identityField: {
                        driverLicense: '',
                        socialSecurity: '',
                        monthMaidenName: '',
                        dataOfBirth: '',
                    },
                    emergency: {
                        contactName: '',
                        contactNumber: '',
                        medicalCondition: '',
                        regularMedication: '',
                        homePhone: '',
                        cellPhone: '',
                        email: '',
                    },
                    new_files: [],
                    customFields: {
                        custom_field_1: '',
                        custom_field_2: '',
                    }
                },
                redirect_link: '',
                emailExistNote: 1
            }
        },
        computed: {
            ...mapGetters({
                userToken: 'userToken',
                userRole: 'userRole',
                userRoleSlug: 'userRoleSlug',
                userClientID: 'userClientID',
                // currentEmployeeID: 'currentEmployeeID',
                loginEmployeeId: 'employeeId',
                getEditEmployeeFrom: 'getEditEmployeeFrom',
                getSubdomain: 'getSubdomain',

            })
        },
        watch: {
            empDetails: function(newData) {
                //console.log(newData);
                this.personalDetails = newData;
                //console.log(this.personalDetails);
                this.currentEmployeeID = newData.id;
                if (this.personalDetails.employable) {
                    this.empPersonal.basicInfo.userName = this.personalDetails.employable.display_name;
                    this.empPersonal.basicInfo.firstName = this.personalDetails.employable.first_name;
                    this.empPersonal.basicInfo.lastName = this.personalDetails.employable.last_name;

                    if (this.personalDetails.employable.addresses.length > 0) {
                        for (let i = 0; i < this.personalDetails.employable.addresses.length; i++) {
                            switch (this.personalDetails.employable.addresses[i].label) {
                                case 'Street':
                                    this.empPersonal.address.streetAdd = this.personalDetails.employable.addresses[i].address;
                                    this.empPersonal.address.city = this.personalDetails.employable.addresses[i].municipality;
                                    this.empPersonal.address.state = this.personalDetails.employable.addresses[i].state_province;
                                    this.empPersonal.address.zip = this.personalDetails.employable.addresses[i].postcode;
                                    this.empPersonal.address.country = this.personalDetails.employable.addresses[i].country;
                                    break;
                                case 'office':
                                    this.empPersonal.address.streetAdd = this.personalDetails.employable.addresses[i].address;
                                    this.empPersonal.address.city = this.personalDetails.employable.addresses[i].municipality;
                                    this.empPersonal.address.state = this.personalDetails.employable.addresses[i].state_province;
                                    this.empPersonal.address.zip = this.personalDetails.employable.addresses[i].postcode;
                                    this.empPersonal.address.country = this.personalDetails.employable.addresses[i].country;
                                    break;
                                case 'P O box':
                                    this.empPersonal.PoBoxAddress.pbAdd = this.personalDetails.employable.addresses[i].address;
                                    this.empPersonal.PoBoxAddress.city = this.personalDetails.employable.addresses[i].municipality;
                                    this.empPersonal.PoBoxAddress.state = this.personalDetails.employable.addresses[i].state_province;
                                    this.empPersonal.PoBoxAddress.zip = this.personalDetails.employable.addresses[i].postcode;
                                    this.empPersonal.PoBoxAddress.country = this.personalDetails.employable.addresses[i].country;
                                    break;
                                default:
                                    this.empPersonal.address.streetAdd = "";
                                    this.empPersonal.PoBoxAddress.pbAdd = "";
                                    this.empPersonal.address.city = "";
                                    this.empPersonal.address.state = "";
                                    this.empPersonal.address.country = "";
                                    this.empPersonal.address.zip = "";
                                    this.empPersonal.PoBoxAddress.city = "";
                                    this.empPersonal.PoBoxAddress.state = "";
                                    this.empPersonal.PoBoxAddress.zip = "";
                                    this.empPersonal.PoBoxAddress.country = "";
                            }
                        }
                    } else {
                        this.empPersonal.address.streetAdd = "";
                        this.empPersonal.PoBoxAddress.pbAdd = "";
                        this.empPersonal.PoBoxAddress.pbAdd = "";
                        this.empPersonal.address.city = "";
                        this.empPersonal.address.state = "";
                        this.empPersonal.address.country = "";
                        this.empPersonal.address.zip = "";
                        this.empPersonal.PoBoxAddress.city = "";
                        this.empPersonal.PoBoxAddress.state = "";
                        this.empPersonal.PoBoxAddress.zip = "";
                        this.empPersonal.PoBoxAddress.country = "";
                    };

                    this.empPersonal.contact.email = this.personalDetails.employable.email;
                    this.employeePrimaryEmail = this.personalDetails.employable.email; 
                    this.empPersonal.contact.secEmail = this.personalDetails.employable.secondary_email;
                    // this.empPersonal.contact.homePhone = this.personalDetails.employable.secondary_email;

                    if (this.personalDetails.employable.phones.length > 0) {
                        for (let i = 0; i < this.personalDetails.employable.phones.length; i++) {
                            switch (this.personalDetails.employable.phones[i].label) {
                                case 'Home phone':
                                    this.empPersonal.contact.homePhone = this.personalDetails.employable.phones[i].phone_number?this.personalDetails.employable.phones[i].phone_number:"";

                                    break;
                                case 'Cell phone':
                                    this.empPersonal.contact.cellPhone = this.personalDetails.employable.phones[i].phone_number?this.personalDetails.employable.phones[i].phone_number :"";
                                    break;
                                case 'cell':
                                    this.empPersonal.contact.cellPhone = this.personalDetails.employable.phones[i].phone_number?this.personalDetails.employable.phones[i].phone_number : "";
                                    break;
                                default:
                                    // this.empPersonal.contact.homePhone = "";
                                    // this.empPersonal.contact.cellPhone = "";
                            }
                        }
                    } else {
                        // this.empPersonal.contact.homePhone = "";
                        // this.empPersonal.contact.cellPhone = "";
                    };

                    this.empPersonal.identityField.driverLicense = this.personalDetails.employable.drivers_license;
                    this.empPersonal.identityField.socialSecurity = this.personalDetails.employable.social_security;
                    this.empPersonal.identityField.monthMaidenName = this.personalDetails.employable.mothers_maiden_name;
                    this.empPersonal.identityField.dataOfBirth = this.personalDetails.employable.dob;

                    if (this.personalDetails.emergency_contact.length > 0) {
                        this.empPersonal.emergency.contactName = this.personalDetails.emergency_contact[0].contact_name;
                        this.empPersonal.emergency.contactNumber = this.personalDetails.emergency_contact[0].contact_number;
                        this.empPersonal.emergency.medicalCondition = this.personalDetails.emergency_contact[0].medical_conditions_note;
                        this.empPersonal.emergency.regularMedication = this.personalDetails.emergency_contact[0].regular_medications;
                        this.empPersonal.emergency.homePhone = this.personalDetails.emergency_contact[0].home_phone_no;
                        this.empPersonal.emergency.cellPhone = this.personalDetails.emergency_contact[0].cell_phone_no;
                        this.empPersonal.emergency.email = this.personalDetails.emergency_contact[0].email;
                    }
                    // this.empPersonal.customFields.custom_field_1= this.personalDetails.custom_field1;
                    // this.empPersonal.customFields.custom_field_2=this.personalDetails.custom_field2;
                    // this.empPersonal.customFields.custom_field_1 =this.personalDetails.custom_field1?JSON.parse(this.personalDetails.custom_field1).value:'';
                    // this.empPersonal.customFields.custom_field_2 = this.personalDetails.custom_field2?JSON.parse(this.personalDetails.custom_field2).value:'';

                    this.empPersonal.customFields.custom_field_1 =this.personalDetails.custom_field1?this.getCustomField(this.personalDetails.custom_field1):'';
                    this.empPersonal.customFields.custom_field_2 = this.personalDetails.custom_field2?this.getCustomField(this.personalDetails.custom_field2):'';
                }
                //console.log(this.personalDetails.employable.addresses[1].address);
                bus.$emit('onUpdatePersonalDetails', this.empPersonal);
            }
        },
        methods: {
            customValEmail(event, customEmailField) {
                if (customEmailField !== "") {
                    // const filter = /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
                    const filter = /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,10}\.[0-9]{1,10}\.)|(([\w-]+\.)+))([a-zA-Z]{2,10}|[0-9]{1,10})(\]?)$/;
                    if (filter.test(customEmailField)) {
                        service.get('user/emailExists', {
                            'Authorization': this.userToken,
                            'email': this.empPersonal.contact.email,
                        }).
                        then((res) => {
                            //console.log("Email Status", res.data.result);
                            // console.log('if' +this.emailExistNote);
                            this.emailExistNote = res.data.result;
                            this.empPersonal.emailExists=res.data.result;

                        }).catch((err) => {
                            console.log(err);
                            this.emailExistNote = 0;
                            this.empPersonal.emailExists=0;
                        });
                        this.onUpdateInputField();
                        $(event.target).next(".customError").css("display", "none");
                    } else {
                        $(event.target).next(".customError").css("display", "block");
                        this.empPersonal.emailExists=-1;
                    }
                } else {
                    $(event.target).next(".customError").css("display", "none");
                    this.emailExistNote = -1;
                    // console.log('else'+this.emailExistNote);
                }
            },
            getDisplayFormat(){
                var format = dateTimeConvert.getDateInputFormat();
                // console.log(format);
                return format?format:'MM/dd/yyyy';
            },
            getDatePlaceholder(){
                return dateTimeConvert.getDatePlaceHolder();
            },
            openCropModal(){
                this.$modal.show('crop-image');
            },
            closeCropModal(){
                this.$modal.hide('crop-image');
            },
            cropImage() {
              // get image data for post processing, e.g. upload or setting image src
              this.cropImg = this.$refs.cropper.getCroppedCanvas().toDataURL();
            },
            rotate() {
              // guess what this does :)
              this.$refs.cropper.rotate(90);
            },
            completeEdit(){
                this.empProfile=this.cropImg;
                this.empPersonal.new_files[0].img=this.cropImg;
                this.$modal.hide('crop-image');
                $('#imgInp').val(null);
                // console.log(this.empPersonal.new_files[0]);
            },
            getPower(data) {
                //console.log('headernav',typeof dateTimeConvert.checkAccess(data));
                return dateTimeConvert.checkAccess(data);
            },
            resetlink() {
                service.post('auth/forgotPassword', {
                    redirect_link: this.redirect_link,
                    email: this.empPersonal.contact.email,
                }, {}).then((res) => {
                    if (res.data.result.status == 0) {
                        this.$notify({
                            title: this.$t('error'),
                            message: res.data.result.message,
                            type: 'error'
                        });
                        //console.log('incorrect');
                    } else {
                       // console.log('correct');
                        this.$notify({
                            title: this.$t('success'),
                            message: this.$t('reset_password_link_sent'),
                            type: 'success'
                        });
                    }

                }).catch((err) => {
                    this.$notify({
                        title: this.$t('error'),
                        message: this.$t('invalid_login_credentials'),
                        type: 'error'
                    });
                });
            },
            addProfileImg(e) {
                // console.log(e.target.value, e.target.result);
                var input = e.target;
                var img;
                if (input.files && input.files[0]) {
                    var reader = new FileReader();
                     //e.target.value;
                    var extension=input.files[0].name.split(".")[input.files[0].name.split(".").length-1];
                    if (input.files[0].size < 30000000 && this.img_format.indexOf(extension) != -1) {
                        reader.onload = (e) => {
                            img = e.target.result;
                            var type = input.files[0].type.split("/");
                            this.empPersonal.new_files[0] = {
                                // 'img': img,
                                'name': input.files[0].name,
                                'status': true,
                                'uploading': false,
                                'uploaded': false,
                                'path': '',
                                'type': type[0],
                                'progress': 0,
                                'label': 'Report'

                            };

                        }
                        reader.readAsDataURL(input.files[0]);
                        this.openCropModal();
                    } else {
                        this.$notify.error({
                            title: this.$t('error'),
                            message: 'Image size should be less than 30 MB and format should be jpg, jpeg, png and gif'
                        });
                    }
                    this.onUpdateInputField();
                }
            },
            blur(event) {
                if ($(event.target).val() === "") {
                    $(event.target).siblings('.form-label').addClass('js-label-transition');
                    this.validation_err = 1;
                } else {
                    $(event.target).siblings('.form-label').removeClass('js-label-transition');
                    this.validation_err = 0;
                }
                this.$validator.validateAll().then((result)=>{
                    if(result)
                        this.validation_err = 0;
                    else
                        this.validation_err = 1;
                });
            },
            blurCellPhone(event, phone){
                let patt=/^\d{10,12}$/g;
                if(!phone || patt.test(phone)|| phone==''){
                    $(event.target).siblings('.form-label').removeClass('js-label-transition');
                    this.cell_phone_error = false;
                    this.validation_err = 0;
                }else{
                    $(event.target).siblings('.form-label').addClass('js-label-transition');
                    this.cell_phone_error = true;
                    this.validation_err = 1;
                }
                this.$validator.validateAll().then((result)=>{
                    if(result)
                        this.validation_err = 0;
                    else
                        this.cell_phone_error = true;
                        this.validation_err = 1;
                });
            },
            blurHomePhone(event, phone){
                // let phone=$(event.target).val();
                // console.log(phone);
                let patt=/^\d{10,12}$/g;
                if(!phone || patt.test(phone)|| phone==''){
                    $(event.target).siblings('.form-label').removeClass('js-label-transition');
                    this.home_phone_error = false;
                    // this.cell_phone_error = false;
                    this.validation_err = 0;
                }else{
                    $(event.target).siblings('.form-label').addClass('js-label-transition');
                    this.home_phone_error = true;
                    // this.cell_phone_error = true;
                    this.validation_err = 1;
                }
                this.$validator.validateAll().then((result)=>{
                    if(result)
                        this.validation_err = 0;
                    else
                        this.home_phone_error = true;
                        // this.cell_phone_error = true;
                        this.validation_err = 1;
                });
            },
            onUpdateInputField() {
                //this.$store.dispatch('saveEmployeeBasicInfo', this.empPersonal.basicInfo);
                bus.$emit('onUpdatePersonalDetails', this.empPersonal);
                //console.log(this.empPersonal);
            },
            // emailExists(){
            //     console.log("Email Status called");
            //     service.get('user/emailExists', {
            //         'Authorization': this.userToken,
            //         'email':this.empPersonal.contact.email,
            //     }).
            //     then((res) => {
            //         console.log("Email Status", res.data.result);

            //     }).catch((err) => {
            //         console.log(err);
            //     });
            //     this.onUpdateInputField();
            // },

            getCustomField(data) {
                // console.log("Fuction Call");

               var customFld = JSON.parse(data);
                let re = -1;
                let re2 = -1;
                if(customFld && customFld.value)
                {
                    // console.log("Check1");
                    re = customFld.value.search('{\"name\":');
                    let inner = "";
                    if(re>=0) {
                        // console.log("Check2");
                        inner = JSON.parse(customFld.value);
                        // console.log(inner);
                        if(inner&&inner != ''&&inner.value)
                            re2 = customFld.value.search('{\"name\":')
                        if(inner.value == "{}" || inner.value == "NULL" || inner.value == "null" || inner.value == "Null" || re2>=0)
                            return '';
                        return inner.value;
                    }else
                        // console.log("Check2 Else");
                        return customFld&&customFld.value&& customFld.value !='{}' && customFld.value !='NULL' && customFld.value!='Null' && customFld.value != 'null' ? customFld.value : '';  
                }
                // console.log("Check1 else")
                return "";
            },
        },
        created() {
            this.getBaseURL = global[0].IMAGE_URL;
            this.empProfile = this.empDetails.employable.image;
            this.redirect_link = 'https://'+this.getSubdomain+'.'+global[0].CLIENT_BASE+'#/resetPassword';
            //this.redirect_link = document.location.href.split('#')[0] + "#/resetPassword";
            //console.log(this.empProfile);
            this.personalDetails = { ... this.empDetails };
            //console.log("employee data", this.empDetails);
            this.currentEmployeeID = this.empDetails.id;
            if (this.personalDetails.employable) {
                this.empPersonal.basicInfo.userName = this.personalDetails.employable.display_name;
                this.empPersonal.basicInfo.firstName = this.personalDetails.employable.first_name;
                this.empPersonal.basicInfo.lastName = this.personalDetails.employable.last_name;

                if (this.personalDetails.employable.addresses.length > 0) {
                    for (let i = 0; i < this.personalDetails.employable.addresses.length; i++) {
                        switch (this.personalDetails.employable.addresses[i].label) {
                            case 'Street':
                                this.empPersonal.address.streetAdd = this.personalDetails.employable.addresses[i].address;
                                this.empPersonal.address.city = this.personalDetails.employable.addresses[i].municipality;
                                this.empPersonal.address.state = this.personalDetails.employable.addresses[i].state_province;
                                this.empPersonal.address.zip = this.personalDetails.employable.addresses[i].postcode;
                                this.empPersonal.address.country = this.personalDetails.employable.addresses[i].country;
                                break;
                            case 'office':
                                this.empPersonal.address.streetAdd = this.personalDetails.employable.addresses[i].address;
                                this.empPersonal.address.city = this.personalDetails.employable.addresses[i].municipality;
                                this.empPersonal.address.state = this.personalDetails.employable.addresses[i].state_province;
                                this.empPersonal.address.zip = this.personalDetails.employable.addresses[i].postcode;
                                this.empPersonal.address.country = this.personalDetails.employable.addresses[i].country;
                                break;
                            case 'P O box':
                                this.empPersonal.PoBoxAddress.pbAdd = this.personalDetails.employable.addresses[i].address;
                                this.empPersonal.PoBoxAddress.city = this.personalDetails.employable.addresses[i].municipality;
                                this.empPersonal.PoBoxAddress.state = this.personalDetails.employable.addresses[i].state_province;
                                this.empPersonal.PoBoxAddress.zip = this.personalDetails.employable.addresses[i].postcode;
                                this.empPersonal.PoBoxAddress.country = this.personalDetails.employable.addresses[i].country;
                                break;
                            default:
                                // this.empPersonal.address.streetAdd = "";
                                // this.empPersonal.PoBoxAddress.pbAdd = "";
                                // this.empPersonal.address.city = "";
                                // this.empPersonal.address.state = "";
                                // this.empPersonal.address.country = "";
                                // this.empPersonal.address.zip = "";
                                // this.empPersonal.PoBoxAddress.city = "";
                                // this.empPersonal.PoBoxAddress.state = "";
                                // this.empPersonal.PoBoxAddress.zip = "";
                                // this.empPersonal.PoBoxAddress.country = "";
                        }
                    }
                } else {
                    this.empPersonal.address.streetAdd = "";
                    this.empPersonal.PoBoxAddress.pbAdd = "";
                    this.empPersonal.PoBoxAddress.pbAdd = "";
                    this.empPersonal.address.city = "";
                    this.empPersonal.address.state = "";
                    this.empPersonal.address.country = "";
                    this.empPersonal.address.zip = "";
                    this.empPersonal.PoBoxAddress.city = "";
                    this.empPersonal.PoBoxAddress.state = "";
                    this.empPersonal.PoBoxAddress.zip = "";
                    this.empPersonal.PoBoxAddress.country = "";
                };

                this.empPersonal.contact.email = this.personalDetails.employable.email;
                this.employeePrimaryEmail = this.personalDetails.employable.email;
                this.empPersonal.contact.secEmail = this.personalDetails.employable.secondary_email;
                if (this.personalDetails.employable.phones.length > 0) {
                    for (let i = 0; i < this.personalDetails.employable.phones.length; i++) {
                        switch (this.personalDetails.employable.phones[i].label) {
                            case 'Home phone':
                                this.empPersonal.contact.homePhone = this.personalDetails.employable.phones[i].phone_number?this.personalDetails.employable.phones[i].phone_number : "";

                                break;
                            case 'home':
                                this.empPersonal.contact.homePhone = this.personalDetails.employable.phones[i].phone_number?this.personalDetails.employable.phones[i].phone_number:"";

                                break;
                            case 'Cell phone':
                                console.log("Sudhakar Check missing cellPhone");
                                console.log(this.personalDetails.employable.phones[i]);
                                this.empPersonal.contact.cellPhone = this.personalDetails.employable.phones[i].phone_number?this.personalDetails.employable.phones[i].phone_number:"";
                                break;
                            case 'cell':
                                this.empPersonal.contact.cellPhone = this.personalDetails.employable.phones[i].phone_number?this.personalDetails.employable.phones[i].phone_number:"";
                                break;
                            default:
                                // this.empPersonal.contact.homePhone = "";
                                // this.empPersonal.contact.cellPhone = "";
                        }
                    }
                } else {
                    this.empPersonal.contact.homePhone = "";
                    this.empPersonal.contact.cellPhone = "";
                };

                this.empPersonal.identityField.driverLicense = this.personalDetails.employable.drivers_license;
                this.empPersonal.identityField.socialSecurity = this.personalDetails.employable.social_security;
                this.empPersonal.identityField.monthMaidenName = this.personalDetails.employable.mothers_maiden_name;
                this.empPersonal.identityField.dataOfBirth = (this.personalDetails.employable.dob != null) ? this.personalDetails.employable.dob.split(" ")[0] : "";

                if (this.personalDetails.emergency_contact.length > 0) {
                    this.empPersonal.emergency.contactName = this.personalDetails.emergency_contact[0].contact_name;
                    this.empPersonal.emergency.contactNumber = this.personalDetails.emergency_contact[0].contact_number;
                    this.empPersonal.emergency.medicalCondition = this.personalDetails.emergency_contact[0].medical_conditions_note;
                    this.empPersonal.emergency.regularMedication = this.personalDetails.emergency_contact[0].regular_medications;
                    this.empPersonal.emergency.homePhone = this.personalDetails.emergency_contact[0].home_phone_no;
                    this.empPersonal.emergency.cellPhone = this.personalDetails.emergency_contact[0].cell_phone_no;
                    this.empPersonal.emergency.email = this.personalDetails.emergency_contact[0].email;
                }

                // this.empPersonal.customFields.custom_field_1= this.personalDetails.custom_field1;
                // this.empPersonal.customFields.custom_field_2=this.personalDetails.custom_field2;
                // this.empPersonal.customFields.custom_field_1 = this.personalDetails.custom_field1?JSON.parse(this.personalDetails.custom_field1).value:'';
                // this.empPersonal.customFields.custom_field_2 = this.personalDetails.custom_field2?JSON.parse(this.personalDetails.custom_field2).value:'';
                this.empPersonal.customFields.custom_field_1 = this.personalDetails.custom_field1?this.getCustomField(this.personalDetails.custom_field1):'';
                this.empPersonal.customFields.custom_field_2 = this.personalDetails.custom_field2?this.getCustomField(this.personalDetails.custom_field2):'';
            }

            service.get('client/' + this.userClientID, {
                'Authorization': this.userToken
            }).
            then((res) => {
                //console.log("Job details", res.data.result);
                this.custom_field_1 = res.data.result.custom_field_1;
                this.custom_field_2 = res.data.result.custom_field_2;
            }).catch((err) => {
                console.log(err);
            });
        },
        mounted() {
            let self=this;
            $(document).on('change', '.btn-file :file', function() {
                var input = $(this),
                    label = input.val().replace(/\\/g, '/').replace(/.*\//, '');
                input.trigger('fileselect', [label]);
            });

            $('.btn-file :file').on('fileselect', function(event, label) {
                var input = $(this).parents('.input-group').find(':text'),
                    log = label;
                if (input.length) {
                    input.val(log);
                } else {
                    if (log) alert(log);
                }
            });

            function readURL(input) {
                var extension=input.files[0].name.split(".")[input.files[0].name.split(".").length-1];
                if (input.files && input.files[0] && input.files[0].size < 30000000 && self.img_format.indexOf(extension) != -1) {
                    var reader = new FileReader();
                    reader.onload = function(e) {
                        // $('#img-upload').attr('src', '');
                        self.cropImg='';
                        self.cropableImg=e.target.result;
                        self.$refs.cropper.replace(e.target.result);

                        var type = input.files[0].type.split("/");
                        self.empPersonal.new_files[0] = {
                            // 'img': img,
                            'name': input.files[0].name,
                            'status': true,
                            'uploading': false,
                            'uploaded': false,
                            'path': '',
                            'type': type[0],
                            'progress': 0,
                            'label': 'Report'
                        };

                        setTimeout(()=>{
                            self.cropImg = self.$refs.cropper.getCroppedCanvas().toDataURL();
                        },1000)
                    }
                    reader.readAsDataURL(input.files[0]);
                }else {
                    self.$notify.error({
                        title: this.$t('error'),
                        message: 'Image size should be less than 30 MB and format should be jpg, jpeg, png and gif'
                    });
                }
                
                self.onUpdateInputField();
                // if (input.files && input.files[0]) {
                //     var reader = new FileReader();
                //     reader.onload = function(e) {
                //         $('#img-upload').attr('src', e.target.result);
                //     }
                //     reader.readAsDataURL(input.files[0]);
                // }
            }

            $("#imgInp").change(function() {
                readURL(this);
            });
            this.onUpdateInputField();

            setTimeout(()=>{
                // console.log('hiiii');
                this.$validator.validateAll().then((result)=>{
                    if(result)
                        this.validation_err = 0;
                    else
                        this.validation_err = 1;
                });
            },2000);
            
        }
    }

</script>
<style scoped>
    .c-user-tab-content1{
        padding: 0;
        border: 3px solid #F67801;
    }

    .c-user-tab-content1 .content-title{
        padding: 15px;
        /* text-align: center; */
        font-size: 18px;
        font-weight: 600;
        margin: 0;
        background-color: #f67801;
        color: #ffffff;
    }

    .c-user-tab-content1 .content-body{
        padding: 15px 20px 20px;
    }

    .disclaimer-note {
        margin-left: 5px;
        margin-top: 5px;
        font-weight: 400;
        font-size: 15px;
        /* padding-bottom: 5px; */
        line-height: 20px;
    }
    .mb-2 {
        margin-bottom: 1em;
    }
    .crop-image-top-margin{
        margin-top: 15px;
    }

</style>



// WEBPACK FOOTER //
// src/components/employees/editEmployeePersonal.vue